import React from 'react';
import Timeline from '../Timeline/Timeline';

const Experience = () => {
    return (
        <Timeline />
    )
}

export default Experience
